import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
    values: {
      collapse: 'mdi-arrow-collapse',
      home: 'mdi-home',
      next: 'mdi-chevron-right',
      previous: 'mdi-chevron-left',
      reload: 'mdi-restart',
      screen: 'mdi-monitor-screenshot',
    },
  },
  theme: {
    options: {
      customProperties: true,
    },
  },
});
